import { observer } from 'mobx-react-lite';
import { useResolve } from '../use';
import { TOKEN_OnboardingStore } from './OnboardingStore';

// The coach and mover screens are P3 and P4. What P2 owes them is the ROUTING: a device that
// scanned the gold coach code has to arrive somewhere that says gold, on the right session, without
// a picker anywhere in sight (docs/access.md).
//
// So this renders the resolved identity and nothing else. It is deliberately not a stub of the real
// screen: a half-built voting screen would be a thing to maintain and a thing to mistake for
// finished. The real ones replace this file's two call sites in AppView.

export const RolePlaceholderView = observer(function RolePlaceholderView() {
  const onboarding = useResolve(TOKEN_OnboardingStore);

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center">
      <span className="text-sm tracking-widest text-neutral-500 uppercase">you are the</span>
      <span className="text-6xl font-bold">
        {onboarding.role}
        {onboarding.court !== undefined && (
          <>
            {' '}
            <span className="uppercase">{onboarding.court}</span>
          </>
        )}
      </span>
      <span className="text-neutral-500">session {onboarding.sessionId}</span>
      <p className="max-w-md text-neutral-400">
        This screen arrives with its phase. Nothing here votes yet.
      </p>
    </div>
  );
});
